"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CALCULATED_VALUE_WHITELIST = exports.CalculationOperator = void 0;

/* eslint-disable */
var CalculationOperator;
exports.CalculationOperator = CalculationOperator;

(function (CalculationOperator) {
  CalculationOperator["ADD"] = "+";
  CalculationOperator["SUBTRACT"] = "-";
  CalculationOperator["MULTIPLY"] = "*";
  CalculationOperator["DIVIDE"] = "/";
  CalculationOperator["EXPONENT"] = "**";
})(CalculationOperator || (exports.CalculationOperator = CalculationOperator = {}));

var CALCULATED_VALUE_WHITELIST = ['customFrequency', 'factors', 'frequency', 'groupId', 'id', 'logId', 'logProjectId', 'name', 'notes', 'projectId', 'units', 'versionSyncStartedAt', 'versionSyncCompletedAt'];
exports.CALCULATED_VALUE_WHITELIST = CALCULATED_VALUE_WHITELIST;